import { useState } from 'react';
import MobileHome from './MobileHome';
import MobileProjectView from './MobileProjectView';
import MobileSettings from './MobileSettings';
import MobileCalendarView from './MobileCalendarView';
import DatabaseView from './DatabaseView';

export default function DesktopDashboardWrapper(props) {
  const [localPath, setLocalPath] = useState('/home');
  const [localSearch, setLocalSearch] = useState('');

  // A fake navigate function that just updates our local state
  const mockNavigate = (to) => {
    if (typeof to === 'string') {
      const [path, search] = to.split('?');
      setLocalPath(path);
      if (search) setLocalSearch('?' + search);
    } else if (typeof to === 'number') {
      // Very basic back handling
      setLocalPath('/home');
    }
  };

  // Extract variables needed to parse route
  const { user } = props;

  // Simple router logic mimicking App.jsx
  if (localPath.startsWith('/p/')) {
    const parts = localPath.split('/');
    // /p/:id/chat, /p/:id/tasks, /p/:id/notes
    const activeModule = parts[3] || 'chat';
    return (
      <div className="h-full w-full overflow-y-auto bg-zinc-50 border-l border-zinc-200">
        <MobileProjectView {...props} user={user} activeModule={activeModule} navigate={mockNavigate} />
      </div>
    );
  }

  if (localPath === '/settings') {
    return (
      <div className="h-full w-full overflow-y-auto bg-zinc-50 border-l border-zinc-200">
        <MobileSettings {...props} user={user} navigate={mockNavigate} />
      </div>
    );
  }

  if (localPath === '/calendar') {
    return (
      <div className="h-full w-full overflow-hidden bg-zinc-50 border-l border-zinc-200">
        <MobileCalendarView {...props} authUser={user} navigate={mockNavigate} />
      </div>
    );
  }

  if (localPath === '/database') {
    return (
      <div className="h-full w-full overflow-hidden bg-zinc-50 border-l border-zinc-200">
        <DatabaseView {...props} navigate={mockNavigate} />
      </div>
    );
  }

  // Default: /home
  return (
    <div className="h-full w-full overflow-y-auto bg-zinc-50 border-l border-zinc-200">
      <MobileHome {...props} user={user} isDesktopDashboard={true} navigate={mockNavigate} />
    </div>
  );
}
